
import { Component, Vue, Prop, Emit, Watch } from 'vue-property-decorator';
import ModalFullScreen from '@/components/modal/ModalFullScreenNew.vue';
import ModalTabs from '@/components/modal/ModalTabs.vue';
import ContractorTable from '@/components/contractors/ContractorTablePopUp.vue';
import UiButton from '@/components/button/ui-button.vue';
import { sendPendingInvites } from '@/services/inviteContractorsPeding';
import Message, { MessageDuration } from '@/data/notificationsMessages';
import { INVITATION, NOTIFICATION } from '@/entities/Events';
import lambdaRequest from "@/helpers/lambdaRequest";

interface UserInterface {
	id: string | null;
	email: string | null;
	givenName: string | null;
	familyName: string | null;
	valid: boolean;
	processing: boolean;
	is_public: boolean;
}

@Component({
	components: {
		ModalFullScreen,
		ModalTabs,
		ContractorTable,
		UiButton,
		sendPendingInvites,
	},
})
export default class ContractorInvite extends Vue {
	// Props and data
	@Prop({ default: false }) readonly showModal!: boolean;
	@Prop({ default: () => [] }) readonly data!: Array<Record<string, any>>;
	  @Prop({ type: String, required: true }) readonly invitedByUserId!: string;
	@Prop({ default: () => [] }) readonly headers!: Array<{
		text: string;
		value: string;
		badge?: boolean;
	}>;
	@Prop({ default: () => [] }) readonly selectedContractors!: Array<any>;

	loading = false;

	// Methods
	handleCancel() {
		this.$emit('close');
	}
	async invite(): Promise<void> {
		try {
			this.loading = true;
			const contractorIds = this.data.map((contractor) => contractor.id);
			const invitedContractorsIds = await sendPendingInvites({
				contractorIds,
			});

			const successMessage = 'Invited';
			const duration = MessageDuration.DEFAULT;
			this.$eventBus.emit(
				NOTIFICATION,
				Message.successMessage(successMessage, duration)
			);

			this.$eventBus.emit(INVITATION);
			window.location.reload();
		} catch (error) {
			this.$eventBus.emit(
				NOTIFICATION,
				Message.errorMessage(error.message)
			);
		} finally {
			this.loading = false;
		}
	}

	// ... other methods
}
